export default () => {

  let loaded = false;

  const $select = $('.js-glossary-mobile'),
        $count = $('.glossary-results-count'),
        $searchButton = $('.js-search-submit'),
        $searchInput = $('.facetwp-search');

  $(document)
    // It happens before any AJAX is requested, and before the URL hash gets updated.
    // This event is useful for modifying any FWP variables before getting sent to the server.
    .on('facetwp-refresh', () => {
      window.packbackLoading.addEvent('facetwp-refresh', true);
    })
    .on('facetwp-loaded', () => {

      if (!loaded) {

        $('.facetwp-type-alpha .facetwp-link:not(.available)').each((index, el) => {

          const $this = $(el),
                value = $this.data('id'),
                $option = $select.find(`option[value="${ value }"]`)
          ;

          $option.prop('disabled', true);

        });

        $select.on('change', () => {
          const val = $select.val();
          $(`.facetwp-type-alpha .facetwp-link.available[data-id="${ val }"]`).trigger('click');
        });

        // Trigger search on button click
        $searchButton.on('click', () => {
          const query = $searchInput.val();
          FWP.facets.search_glossary = query;
          FWP.refresh();
        });

        loaded = true;
      }

      if (FWP.facets.search_glossary) {
        $count.show();
      } else {
        $count.hide();
      }

      // Add .selected to 'All' option
      // $('.facetwp-type-alpha .facetwp-link[data-id=""]').toggleClass('selected', !FWP.facets.glossary.length);

      // End the loading event
      window.packbackLoading.endEvent('facetwp-refresh');

    })
  ;

};